import { render, staticRenderFns } from "./RelProfissionais.vue?vue&type=template&id=9d8c01b0"
import script from "./RelProfissionais.vue?vue&type=script&lang=js"
export * from "./RelProfissionais.vue?vue&type=script&lang=js"
import style0 from "./RelProfissionais.vue?vue&type=style&index=0&id=9d8c01b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports